import React from "react";

const DogsModalCallbackContext = React.createContext<{
  dogsModalCallback: () => void;
  setDogsModalCallback: React.Dispatch<React.SetStateAction<() => void>>;
} | null>(null);

export default DogsModalCallbackContext;
